import React, { FC } from 'react';
import { Box } from '@mui/material';

interface RankBadgeProps {
  rank: number;
  size?: number;
}

const RANK_PALETTE: Record<number, { bg: string; color: string }> = {
  1: { bg: '#FEF3C7', color: '#B45309' },
  2: { bg: '#E5E7EB', color: '#4B5563' },
  3: { bg: '#FDE0C7', color: '#B45309' },
};

const RankBadge: FC<RankBadgeProps> = ({ rank, size = 26 }) => {
  const styles = RANK_PALETTE[rank] ?? { bg: '#F1F5F9', color: '#64748B' };

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: styles.bg,
        color: styles.color,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: '0.8125rem',
      }}>
      {rank}
    </Box>
  );
};

export default RankBadge;
